import { baseService } from './baseService'
import { STATUS_CODE } from '../data/system_settings'
import Response from '../data/entity/response_entity'

class FacultyService extends baseService {
  async getAll() {
    const res = await this.get('references/faculty')
    if (res.status === STATUS_CODE.SUCCESS) {
      return Response({
        success: true,
        message: {
          content: res.data.data,
        },
      })
    } else {
      return Response({
        success: false,
        message: {
          content: 'Không thể tải danh sách khoa viện.',
        },
      })
    }
  }
}

export const facultyService = new FacultyService()
